import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-mail",
  "use": "icon-cl-mail-usage",
  "viewBox": "0 0 38 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 32\" id=\"icon-cl-mail\"><path d=\"M0 32V0l38 16L0 32Zm3-4.65L30.2 16 3 4.5v8.4L15.1 16 3 19v8.35Zm0 0V4.5v22.85Z\" fill=\"#41484D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol